import * as yup from "yup";
import Toast from "helper/toast";

//////////////////// file sizes and formates ////////////////////
export const FILE_SIZE = 10_000_000; //10 meg

//////////////////// constant validation message ////////////////////
function strings({ title = "فیلد", size = "۵ مگ" }) {
  return {
    required: "این فیلد حتما باید پر شود",
    notMatch: title + " نامعتبر است ",
    size: `سایز ${title} باید کمتر از ${size} باشد`,
    min: `${title} حداقل باید ${size} حرف باشد`,
    unSupported: `فرمت ${title} نامعتبر است`,
  };
}

/////////////////// convert empty stringToNull ///////////////////
function emptyStringToNull(value, originalValue) {
  if (typeof originalValue === "string" && originalValue === "") {
    return null;
  }
  return value;
}

///////////////// Image validator ///////////////////
export function validateImg(file) {
  if (!(file.type.split("/")[0] === "image")) {
    return Toast({
      type: "custom-warn",
      title: `فرمت عکس نامعبتر است`,
      autoClose: 3000,
    });
  } else if (file.size > FILE_SIZE) {
    return Toast({
      type: "custom-warn",
      //converting kb to megabyte
      title: `حجم عکس باید کمتر از ${FILE_SIZE / 1_000_000}  مگ باشد`,
      autoClose: 3000,
    });
  }
}

/////////////// Login User ///////////////
export const loginOtpSchema = yup
  .object({
    phone_number: yup
      .string()
      .required(strings("").required)
      .matches(
        /^[\u06F0-\u06F90-9]+$/,
        strings({ title: "نلفن همراه" }).notMatch
      )
      .min(11, strings({ title: "نلفن همراه" }).notMatch)
      .max(11, strings({ title: "نلفن همراه" }).notMatch),
    otp: yup
      .string()
      .matches(/^[0-9]+$/, strings({ title: "کد" }).notMatch)
      .min(6, strings({ title: "کد وارد شده", size: 6 }).min)
      .max(6, "کد وارد شده باید 6 رقم باشد", strings("").max),
  })
  .required();

/////////////// Login Colleague ///////////////
export const loginColleagueSchema = yup
  .object({
    phone_number: yup
      .string()
      .required(strings("").required)
      .matches(
        /^[\u06F0-\u06F90-9]+$/,
        strings({ title: "نلفن همراه" }).notMatch
      )
      .min(11, strings({ title: "نلفن همراه" }).notMatch)
      .max(11, strings({ title: "نلفن همراه" }).notMatch),
    password: yup
      .string()
      .required(strings("").required)
      .min(6, strings({ title: "رمز وارد شده", size: 6 }).min),
  })
  .required();

/////////////// Add To Shopping Cart ///////////////
export const AddToCartSchema = yup.object({}).required();

/////////////// Add To Shopping Cart ///////////////
export const AddDiscount = yup
  .object({
    discount_code: yup.string().nullable(),
    description: yup.string().nullable(),
  })
  .required();

////////////////// contact us  //////////////////
export const contactSchema = yup
  .object({
    full_name: yup.string().required(strings("").required),
    email: yup
      .string()
      .email("ايميل نا معتبر است")
      .required(strings("").required),
    message: yup.string().required(strings("").required),
  })
  .required();

////////////////// addName  //////////////////
export const addNameSchema = yup
  .object({
    full_name: yup.string().required(strings("").required),
  })
  .required();

////////////////// contact us  //////////////////
export const complaintSchema = yup
  .object({
    full_name: yup.string().required(strings("").required),
    subject: yup.string().required(strings("").required),
    email: yup
      .string()
      .email("ايميل نا معتبر است")
      .required(strings("").required),
    phone_number: yup
      .string()
      .required(strings("").required)
      .matches(
        /^[\u06F0-\u06F90-9]+$/,
        strings({ title: "نلفن همراه" }).notMatch
      )
      .min(11, strings({ title: "نلفن همراه" }).notMatch)
      .max(11, strings({ title: "نلفن همراه" }).notMatch),
    message: yup.string().required(strings("").required),
  })
  .required();

/////////////// Edit normal User ///////////////
export const editNormalUserSchema = yup
  .object({
    full_name: yup.string().required(strings("").required),
    email: yup
      .string()
      .email("ايميل نا معتبر است")
      .transform(emptyStringToNull)
      .nullable(),
  })
  .required();

/////////////// add address ///////////////
export const AddAddressSchema = yup
  .object({
    address: yup.string().required(strings("").required),
    state: yup.string().required(strings("").required),
    city: yup.string().required(strings("").required),
    postal_code: yup.string().required(strings("").required),
  })
  .required();

/////////////// add address ///////////////
export const EditAddressSchema = yup
  .object({
    // address: yup.string().required(strings("").required),
    // state: yup.string().required(strings("").required),
    city: yup.string().required(strings("").required),
    postal_code: yup.string().required(strings("").required),
  })
  .required();

////////////////// addName  //////////////////
export const addCommentSchema = yup
  .object({
    title: yup.string().required(strings("").required),
    description: yup.string().required(strings("").required),
  })
  .required();

/////////////// add ticket ///////////////
export const AddTicketSchema = yup
  .object({
    title: yup.string().required(strings("").required),
    text: yup.string().required(strings("").required),
  })
  .required();

/////////////// add ticket message ///////////////
export const EditTicketSchema = yup
  .object({
    text: yup.string().required(strings("").required),
  })
  .required();

////////////////// Question  //////////////////
export const addQuestionSchema = yup
  .object({
    description: yup.string(),
    answer: yup.string(),
  })
  .required();

////////////////// Answer  //////////////////
export const addAnswerSchema = yup
  .object({
    answer: yup.string().required(strings("").required),
  })
  .required();
